import lambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';

const ALLOWED_FIELDS = [
    'geofenceId',
    'name',
    'description',
    'style',
    'start',
    'end',
    'geojson',
    'notification',
];

export function transformIn(geofence) {
    if (geofence.style) {
        try {
            geofence.style = JSON.parse(geofence.style);
        } catch(e) {
            geofence.style = {}
            console.error('error parsing geofence style', geofence.style, e);
        }
    }
    if (geofence.geojson) {
        try {
            const { geometry, properties } = JSON.parse(geofence.geojson);
            geofence.geojson = {
                geometry,
                properties
            };
        } catch(e) {
            geofence.geojson = {}
            console.error('error parsing geofence geojson', geofence.geojson, e);
        }
    }
    if (geofence.end) {
        geofence.end = new Date(geofence.end);
    }
    return geofence;
}

// return a new plain object containing only the properties included in propertyNames
function filterObject(obj, propertyNames) {
    return propertyNames.reduce((acc, name) => {
        if(obj[name] !== undefined) acc[name] = obj[name];
        return acc;
    }, {});
}

function transformOut(geofence) {
    if (geofence.style) {
        geofence.style = JSON.stringify(geofence.style);
    }
    if (geofence.geojson) {
        const { geometry, properties } = geofence.geojson;
        geofence.geojson = JSON.stringify({ geometry, properties });
    }
    if (geofence.end) {
        geofence.end = geofence.end.toISOString();
    }
    return filterObject(geofence, ALLOWED_FIELDS);
}

export function fetchActiveGeofences(stage) {
    return lambdaUtil.getActiveGeofences(stage)
        .then(response => {
            return response.activeGeofences.map(transformIn);
        });
}

export function addGeofence(stage, geofence) {
    // geofence = {
    //     name: 'New Geofence',
    //     style: {
    //         "fill-color": "#cc00aa"
    //     }
    // };
    return lambdaUtil.addGeofence(stage, transformOut(geofence))
        .then(response => transformIn(response.addGeofence.geofence));
}

export function removeGeofence(stage, geofenceId) {
    return lambdaUtil.removeGeofence(stage, geofenceId);
}

export function updateGeofence(stage, geofence) {
    return lambdaUtil.updateGeofence(stage, transformOut(geofence))
        .then(response => transformIn(response.updateGeofence.geofence));
}

export function lookupAddress(lon, lat) {
    return new Promise((resolve, reject) => {
        RavenUtil.getLocationFeatures(lon, lat, resolve, reject);
    }).then(response => {
        return RavenUtil.getLocationName(response);
    });
};
